import { gql } from '@apollo/client'

const REPLACE_ACTION_GOAL = gql`
  mutation replaceActionGoal($id: ID!, $actionGoal: CreateActionGoal!) {
    replaceActionGoal(id: $id, actionGoal: $actionGoal) {
      newActionGoal {
        id
      }
      deletedActionGoal {
        id
      }
    }
  }
`

export default REPLACE_ACTION_GOAL
